<template>
  <div class="map">
    <map-panel />
  </div>
</template>

<script>
import MapPanel from '../components/organisms/Map/MapPanel'

export default {
  created () {
    const serviceAreaId = this.$route.query.serviceAreaId
    const reservationId = this.$route.query.reservationId
    const token = this.$route.query.token

    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('reservation/activateMode', parseInt(serviceAreaId))

    if (token) {
      this.$store.dispatch('user/create', { serviceAreaId, token })
        .then(() => {
          this.$store.dispatch('serviceAreas/fetch', serviceAreaId)
          this.$store.dispatch('busstops/fetchAll')
            .finally(() => {
              this.$store.dispatch('reservation/fetchAndSetup', reservationId)
              this.$store.dispatch('loading/endLoading')
            })
        })
    }
  },
  components: {
    MapPanel
  }
}
</script>
